var Backbone = require('backbone');
var $ = require('jquery');
var template = require('../templates/vote-option.ejs');
var templateAlt = require('../templates/vote-option-finalist.ejs');
var PubSub = require('tscom-pubsub');
var imagesLoaded = require('imagesloaded');

module.exports = Backbone.View.extend({
    className: 'view-vote-item',
    tagName: 'li',
    events: {
        'click .contestant' : 'selectContestant',
        'mouseenter .contestant' : 'changeColor',
        'mouseleave .contestant' : 'changeColor'
    },
    /**
     *
     */
    initialize: function (options) {
        
        this.cms = options.cms;
        this.voteOption = options.voteOption;
        this.router = options.router;
        this.dataLength = options.dataLength;

    },
    /**
     *
     */
    render: function () {
            
        var dataLength = this.dataLength;
        var model = this.model.toJSON();
        
        // check length of vote option name and slice it
        var fullName = model.firstname + ' ' + model.lastname;
        if(fullName.length >= 74) fullName = fullName.slice(0,73);
        model.fullname = fullName;

        var text = this.cms.get('text')['views_nominee_grid'];
        //check the length of the contestants, render different layout based on contestant length
        if (dataLength === 2 || dataLength === 4) {
            this.$el.html(templateAlt({
                model: model,
                text: text
            }));
            return this;
        }

        this.$el.html(template({
            model: model,
            text: text
        }));

        return this;
    },
    renderedToDOM: function(){
        imagesLoaded(this.el.querySelector('.contestant-img'), function(){
            this.relayVoteItemHeight();
            this.listenTo(PubSub, 'AnimationFrame', this.relayVoteItemHeight.bind(this));
        }.bind(this));

    },
    /**
     *
     */
    selectContestant: function (e) {
        
        e.preventDefault();
        this.voteOption.setSelected(this.model.get('id'));
        
        // pass vote event to google if 1 click vote enabled
        // if (this.cms.get('text')['views_nominee_grid'].disable_confirmation_modal == "true" && this.controller.Models.Auth.get('isAuthorized')) {
        //  this.controller.trackEvent(e, 'eventClickVote');
        // } else {
        //  this.controller.trackEvent(e, "eventClickContestant");
        // }

        this.router.scrollToTop();
    },
    /**
     *
     */
    changeColor: function (e) {
        var $target = $(e.currentTarget).find('.vote');

        if($target.length === 0) {
            $target = $(e.currentTarget).find('.eliminated-vote');
            $target.toggleClass('hoverElim');
            return;
        }
        $target.toggleClass('hover');
    },
    /**
     * [relayVoteItemHeight description]
     * @return {[type]} [description]
     */
    relayVoteItemHeight: function () {

        if(typeof this.myHeight === 'undefined' || this.myHeight !== this.$('.item-measure-contents').outerHeight()){
            if ( this.$('.contestant').length ) {
                this.myHeight = this.$('.item-measure-contents').outerHeight();
                console.log('relayVoteItemHeight', this.myHeight);
                PubSub.trigger('relayVoteItemHeight', this.myHeight);
            }
        }

    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/standard-vote/app/scripts/views/vote-option.js
// module id = 99
// module chunks = 0